import { Initializer } from 'js-common';

// Controllers
import ArticleModal from './ArticleModal';
import ArticleSlider from './ArticleSlider';
import Focus from './Focus';
import General from './General';
import LoadMore from './LoadMore';
import Timeline from './Timeline';
import Toggle from './Toggle';

const initializer = new Initializer();
// Init in some order of importance
initializer.initControllers([
  General,
  Focus,
  Toggle,
  LoadMore,
  Timeline,
  ArticleSlider,
  ArticleModal,
]);
